<template>
  <v-card flat width="auto" max-width="400"  class="overflow-hidden"
  :color="$vuetify.theme.dark ? '' : 'grey lighten-3'">
    <v-list flat >
      <v-card flat v-if="$userInfo.profile">
        <v-row class="px-6 pb-4">
          <v-col cols="12" class="d-flex justify-start align-start ma-0 pa-0 ml-2">
            <!-- <v-badge
            bordered
        color="primary"
        icon="mdi-security"
        overlap
        bottom

      >
      <v-avatar size="50" v-if="$userInfo.profile.photo" >
              <v-img :src="$userInfo.profile.photo" :alt="$userInfo.profile.displayName">
              </v-img>
            </v-avatar>
            <v-avatar color="primary" size="50" v-else>
              <span class="white--text text-h6">{{ $userInfo.profile.initials }}</span>
            </v-avatar>
      </v-badge> -->
            <v-avatar size="50" v-if="$userInfo.profile.photo" class="mt-4">
              <v-img :src="$userInfo.profile.photo" :alt="$userInfo.profile.displayName">
              </v-img>
            </v-avatar>
            <v-avatar color="primary" size="50" v-else>
              <span class="white--text text-h6">{{ $userInfo.profile.initials }}</span>
            </v-avatar>

            <v-list-item class="px-2 pl-4" three-line>
              <v-list-item-content>
                <v-list-item-title class="mb-0">
                  <span class="text-h6 no-wrap">
                    {{ $userInfo.profile.displayName }}
                    <!-- Prashanth Shivasubramani Shantanu -->
                  </span>
                  <!-- {{ $userInfo.profile.displayName }} -->
                </v-list-item-title>
                <v-list-item-subtitle style="line-height: 1.5;">
                  {{ $userInfo.profile.jobTitle }}
                  <!-- Sr Engineer II - Appdev -->
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="$userInfo.profile.isAdmin" class="pt-1">
                  <v-chip outlined small  >Admin</v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

          </v-col>
        </v-row>
      </v-card>
    </v-list>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      settings: [],
      theme: []
    }
  },
  methods: ({
    toggleTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      localStorage.setItem('isDarkTheme', this.$vuetify.theme.dark)
    },
    openHelpSupportDialog () {
      this.$emit('openHelpSupportDialog')
    }
  }),
  // watch for changes of the theme and call the toggleTheme method
  watch: {
    theme: function () {
      this.toggleTheme()
    }
  },
  mounted () {
    // scroll with ease in animation to the top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

}
</script>
